




import { Component, Vue } from 'vue-property-decorator';
import { Viewer } from 'photo-sphere-viewer';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css';

// 小程序里的全景图插件
@Component
export default class MiniVrIndex extends Vue {
  public msg = '';
  public html: any = null;

  // 小程序里通过url传参
  public async mounted() {
    const url = decodeURIComponent(this.querystring(window.location.search).url);
    this.html = document.getElementsByTagName('html');
    this.html[0].style.overflowY = 'hidden';
    document.title = '汀薹软装全景图';

    if (!url) {
      this.msg = '图片地址为空';
      return;
    }
    const viewer = new Viewer({
      container: document.querySelector('#viewer'),
      panorama: url,
      navbar: ['autorotate', 'zoom'],
    });
  }

  public destroyed() {
    this.html[0].removeAttribute('style');
  }

  // 将 url 里的 search 字符串解析为对象
  public querystring(searchStr: string) {
    return searchStr.slice(1).split('&').reduce((acc, cur) => {
      const arr = cur.split('=');
      acc[arr[0]] = decodeURIComponent(arr[1]);
      return acc;
    }, {} as Record<string, any>);
  }
}
